import jsPDF from "jspdf";
import "jspdf-autotable";
import { PDFDocument, rgb, StandardFonts, degrees, PDFName, PDFString, TextAlignment, setFillingRgbColor, setFontAndSize, layoutMultilineText, setBorderColor } from "pdf-lib";
import axios from "@/plugins/axios";

class PDFSolarCollectifGenerator {
  constructor(data) {
    this.pdfData = data ? data.pdfData : {};
    this.compteurs = data?.pdfData?.listeCompteur ? Object.values(data.pdfData.listeCompteur) : [];
    this.resultatDivisionSolar = data?.pdfData?.resultatDivisionSolar ? Object.values(data.pdfData.resultatDivisionSolar) : [];
    this.simulationEcoList = [
      {
        "prixDuKWhAnnuelleTTC": "1668021",
        "factureEnergieTTCSansPV": "1668022",
        "factureEnergieTTCAvecPV": "1668023",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668025",
        "coutDeLaMaintenanceTTC": "1668026",
        "delta": "1668027",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
      {
        "prixDuKWhAnnuelleTTC": "1668024",
        "factureEnergieTTCSansPV": "1668024",
        "factureEnergieTTCAvecPV": "1668024",
        "autoconsommationCollectiveTTC": "1668024",
        "venteDuSurplusDeProductionTTC": "1668024",
        "coutDeLaMaintenanceTTC": "1668024",
        "delta": "1668024",
      },
    ];
    this.rsiAns = 8;
    this.rsi = -1643836.43;
    this.addressImage = data?.addressImage;
    this.cellpinageImage = data?.cellpinageImage;
    // colors
    this.COLOR = {
      black: [0,0,0],
      white: [1,1,1],
      red: [1,0,0],
      grey100: [0.949,0.949,0.949],
      grey200: [0.901,0.901,0.901],
      darkGrey: [0.854,0.854,0.854],
      skyBlue: [0.0039, 0.7019, 0.7686],
      lightBlue2: [0.180, 0.458, 0.713],
      blue100: [0.8509,0.8823,0.949],
      blue200: [0.745, 0.901, 0.96],
      blue400: [0.549, 0.647, 0.843],
      blue600: [0.078, 0.372, 0.509],
      darkBlue: [0.0705, 0.149, 0.3686],
      darkBlue2: [0.121, 0.286, 0.49],
      yellow500: [1, 0.843, 0.392],
      yellow: [1, 0.949, 0.407],
      lightYellow: [1, 0.949, 0.8],
      green: [0, 0.690, 0.313],
      greenGrass100: [0.862, 0.921, 0.843],
      greenGrass200: [0.647, 0.803, 0.549],
      greenGrass300: [0.568, 0.803, 0.313],
      greenGrass: [0.4392, 0.6784, 0.2784],
      greenGrassDark: [0.329, 0.509, 0.207],
      orange100: [0.98,0.88, 0.82],
    };
  }

  // --------------------- pdf generation --------------------- 
  async generatePresentation() {
    try {
      let mergedPdf = await PDFDocument.create();

      let pageNumber = 1;
      // ------------ photo uploaded AMO pour la réalisation des installations ------------
      const page1Doc = await this.page1("/pdf/solar-collectif/EECI/EECI-1.pdf");
      mergedPdf = await this.addPagesToPdf(mergedPdf, page1Doc);
      pageNumber++ // increment pageNumber

      // ------------ PÉRIMÈTRE ------------
      // const page2Doc = await this.pageChapter(
      //   "/pdf/solar-collectif/EECI/EECI-blue-empty.pdf",
      //   "PÉRIMÈTRE", 
      //   "Installation photovoltaïques en toitures et en ombrières",
      // );
      // mergedPdf = await this.addPagesToPdf(mergedPdf, page2Doc);
      // pageNumber++ // increment pageNumber

      // ------------ Reportage Photo ------------ 
      // const page3Doc = await this.pageReportagePhoto("/pdf/solar-collectif/EECI/EECI-blue-empty.pdf");
      // mergedPdf = await this.addPagesToPdf(mergedPdf, page3Doc);
      // pageNumber++ // increment pageNumber
      
      // ################################################################# 
      // ########################### scénarios ########################### 
      // #################################################################
      // ------------ SCÉNARIO 1 ------------
      const page4Doc = await this.pageChapter(
        "/pdf/solar-collectif/EECI/EECI-blue-empty.pdf",
        `SCÉNARIO 1`,
        // "Solarisation des toitures uniquement",
        // ["7 installations photovoltaïques en toitures - 1 162 kWc"]
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, page4Doc);
      pageNumber++ // increment pageNumber

      // ------------ Calepinage ------------
      const pageCalepinageDoc = await this.pageCalepinage(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
        `1`,
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageCalepinageDoc);
      pageNumber++ // increment pageNumber

      // ------------ Investissement ------------
      const filteredCompteurs = this.compteurs.filter(cpt=> 
        ["autoCollective&Individuelle","production","autoCollective"].includes(cpt.typeProduction)
      )
      for (let i=0; i < filteredCompteurs.length; i+=2) {
        const investPageData = [];
        // first compteur to display
        investPageData.push({
          num_compteur: filteredCompteurs[i].Numero_Compteur,
          installationsTotal: filteredCompteurs[i].dataMaintenance.installationsTotal,
          installations: filteredCompteurs[i].dataMaintenance.installations,
        });
        // second compteur to display if exist
        if(i+1 < filteredCompteurs.length){
          investPageData.push({
            num_compteur: filteredCompteurs[i+1].Numero_Compteur,
            installationsTotal: filteredCompteurs[i+1].dataMaintenance.installationsTotal,
            installations: filteredCompteurs[i+1].dataMaintenance.installations,
          })
        }
        const pageInvestissementDoc = await this.pageInvestissement(
          "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
          `1`,
          `${pageNumber}`,
          investPageData,
        );
        mergedPdf = await this.addPagesToPdf(mergedPdf, pageInvestissementDoc);
        pageNumber++ // increment pageNumber
      }

      // ------------ Fonctionnement ------------
      for (let i=0; i < filteredCompteurs.length; i+=2) {
        const pageData = [];
        // first compteur to display
        pageData.push(filteredCompteurs[i]);
        // second compteur to display if exist
        if(i+1 < filteredCompteurs.length){
          pageData.push(filteredCompteurs[i+1])
        }
        const pageFonctionnementDoc = await this.pageFonctionnement(
          "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
          `1`,
          `${pageNumber}`,
          pageData,
        );
        mergedPdf = await this.addPagesToPdf(mergedPdf, pageFonctionnementDoc);
        pageNumber++ // increment pageNumber
      }

      // ------------ Production annuelle ------------
      
      if (filteredCompteurs.length>=1) {
        const pageProductionAnnuelleRes = await this.pageProductionAnnuelle(
          "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
          `1`,
          pageNumber, 
          mergedPdf,
          filteredCompteurs
        );
        mergedPdf = await this.addPagesToPdf(mergedPdf, pageProductionAnnuelleRes.pdfDoc);
        pageNumber = pageProductionAnnuelleRes.pageNumber + 1 // increment pageNumber
      }

      // ------------ Répartition de l’énergie produite ------------
      const pageRepartitionEnergieProduiteDoc = await this.pageRepartitionEnergieProduite(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
        `1`,
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageRepartitionEnergieProduiteDoc);
      pageNumber++ // increment pageNumber

      // ------------ Detail Compteur ----------------
      for (let i = 0; i < this.resultatDivisionSolar.length; i++) {
        const compteur = this.resultatDivisionSolar[i];
        const pageDetailCompteurRes = await this.pageDetailCompteur(
          "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
          `1`,
          pageNumber,
          compteur,
          mergedPdf,
        );
        mergedPdf = await this.addPagesToPdf(mergedPdf, pageDetailCompteurRes.pdfDoc);
        pageNumber = pageDetailCompteurRes.pageNumber + 1 // increment pageNumber
      }

      /*
      
      // ------------ Simulation économique ------------
      const pageSimulationEconomiqueRes = await this.pageSimulationEconomique(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
        `1`,
        pageNumber,
        mergedPdf
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageSimulationEconomiqueRes.pdfDoc);
      pageNumber = pageSimulationEconomiqueRes.pageNumber + 1 // increment pageNumber

      // ------------ Estimation - Facture énergie ------------
      const pageEstimationFactureEnergieDoc = await this.pageEstimationFactureEnergie(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
        `1`,
        `${pageNumber}`
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageEstimationFactureEnergieDoc);
      pageNumber++ // increment pageNumber

      // ------------ Retour Sur Investissement (RSI) ------------
      const pageRetourInvestissementDoc = await this.pageRetourInvestissement(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf", 
        `1`,
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageRetourInvestissementDoc);
      pageNumber++ // increment pageNumber

      
      
      // ################################################################# 
      // ########################### SYNTHÈSE ########################### 
      // #################################################################
      const pageChapterSyntheseDoc = await this.pageChapter(
        "/pdf/solar-collectif/EECI/EECI-blue-empty.pdf",
        "SYNTHÈSE",
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageChapterSyntheseDoc);
      pageNumber++ // increment pageNumber

      // ------------ Récapitulatif des scenarios ------------
      const pageSyntheseRecapitulatifDoc = await this.pageSyntheseRecapitulatif(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf",
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageSyntheseRecapitulatifDoc);
      pageNumber++ // increment pageNumber

      // ------------ list "Synthèse Scénario" ------------
      const kwc = this.formatNumberOrText(-1162, 3);
      const invest = this.formatNumberOrText(1.433, 3);
      const title = `Scénario n°1 –Solarisation des toitures uniquement ${kwc} kWc: ~= Invest. ${invest} M€ TTC`;
      const subtitle = `5 453 m2 en toitures et 853 m2 en ombrières`;
      const autoConsoIndivCollective = this.formatNumberOrText(99.95, 2) + "%";
      const tauxReventeSurplus = this.formatNumberOrText(0.05, 2) + "%";
      const tauxBesoinEnergitiqueGlobale = this.formatNumberOrText(8.7, 2) + "%";
      const economie6 = this.formatNumberOrText(1.22, 2) + " M€";
      const economie9 = this.formatNumberOrText(2.18, 2) + " M€";
      const economie12 = this.formatNumberOrText(3.48, 2) + " M€";
      const rsiAns = `${this.rsiAns} ans`;

      const pageSyntheseDoc = await this.pageSynthese(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf",
        {title, subtitle, autoConsoIndivCollective,tauxReventeSurplus,tauxBesoinEnergitiqueGlobale,economie6,economie9,economie12,rsiAns},
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageSyntheseDoc);
      pageNumber++ // increment pageNumber

      // ------------ PLANNING PRÉVISIONNEL ------------ 
      const pageChapterPlanningDoc = await this.pageChapter(
        "/pdf/solar-collectif/EECI/EECI-blue-empty.pdf",
        "PLANNING PRÉVISIONNEL",
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pageChapterPlanningDoc);
      pageNumber++ // increment pageNumber

      // ------------ Planning ------------
      const pagePlanningDoc = await this.pagePlanning(
        "/pdf/solar-collectif/EECI/EECI-white-empty.pdf",
        `${pageNumber}`,
      );
      mergedPdf = await this.addPagesToPdf(mergedPdf, pagePlanningDoc);
      pageNumber++ // increment pageNumber

      */
      // ******************** save pdf ******************** 
      const filledPdfBytes = await mergedPdf.save();

      // ******************** Download the filled PDF ******************** 
      const blob = new Blob([filledPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Présentation-EECI.pdf";
      link.click();
    } catch (error) {
      console.log(error)
    }
  }
  // to merge pdf pages
  async addPagesToPdf(mergedPdf, donnerPdf, pageRotation) {
    const copiedPages = await mergedPdf.copyPages(
        donnerPdf,
        donnerPdf.getPageIndices()
    )
    copiedPages.forEach((page) => {
        if(pageRotation){
            page.setRotation(degrees(pageRotation));
        }
        mergedPdf.addPage(page)
    })
    return mergedPdf;
  }

  // initializing pdf loading and global variables
  async init(pdfPath){
    const response = await fetch(pdfPath);
    const arrayBuffer = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    const pages = pdfDoc.getPages();
    const page = pages[0];
    const pageSize = page.getSize();

    const fontFamily = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontFamilyItalic = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);
    const fontFamilyBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const fontFamilyBoldItalic = await pdfDoc.embedFont(StandardFonts.HelveticaBoldOblique);

    const xCenterPosition = pageSize.width / 2;
    const yCenterPosition = pageSize.height / 2;
    const xCenterPositionWithGap = xCenterPosition + 40;

    const xStartLeft = 113;

    return {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    }
  }
  async loadPdfFromPath(pdfPath) {
    // Load the PDF from the project folder
    const response = await fetch(pdfPath);
    const arrayBuffer = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);
  
    return pdfDoc;
  }

  // --------------------- functions for filling pdf --------------------- 
  async page1(pdfPath){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
    } = await this.init(pdfPath);

    const imageWidth = 420;
    const imageHeight = 280;
    const x = xCenterPosition - (imageWidth / 2);
    const y = 140;

    // Upload image from input file
    const imageFile = this.addressImage;

    await this.drawRoundedImage(pdfDoc, page, imageFile, x, y, imageWidth, imageHeight, 10)

    return pdfDoc;
  }
  async pageChapter(pdfPath, chapter, title="", description=[], puissanceCreteTotale=null){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
    } = await this.init(pdfPath);

    // chapter
    this.drawAlignedText({
      page: page, 
      text: chapter, 
      x: xCenterPosition, 
      y: yCenterPosition, 
      font: fontFamilyBold, 
      size: 32, 
      align: 'center', 
      textColor: this.COLOR.white, 
    });
    // title
    this.drawAlignedText({
      page: page, 
      text: title, 
      x: xCenterPosition, 
      y: yCenterPosition - 25, 
      font: fontFamilyBold, 
      size: 16, 
      align: 'center', 
      textColor: this.COLOR.skyBlue, 
    });
    
    // description
    let yDescription = yCenterPosition - 45;
    for (let i = 0; i < description.length; i++) {
      this.drawAlignedText({
        page: page, 
        text: description[i], 
        x: xCenterPosition, 
        y: yDescription, 
        font: fontFamily, 
        size: 14, 
        align: 'center', 
        textColor: this.COLOR.yellow, 
      });
      yDescription = yDescription - 17;
    }

    // Puissance crête totale
    if(puissanceCreteTotale){
      this.drawAlignedText({
        page: page, 
        text: `Puissance crête totale : ${puissanceCreteTotale} kWc`, 
        x: xCenterPosition, 
        y: yDescription, 
        font: fontFamilyBold, 
        size: 14, 
        align: 'center', 
        textColor: this.COLOR.yellow, 
      });
    }

    
    return pdfDoc;
  }
  async pageReportagePhoto(pdfPath){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
    } = await this.init(pdfPath);

    // Image list
    const imageWrapperMaxWidth = pageSize.width - 30;
    const gap = 15;
    const imageWidth = (pageSize.width - (6*gap))/5;
    const imageHeight = imageWidth;

    const imgYPosition = yCenterPosition - (imageHeight / 2)
    
    // Upload image from input file
    const imageFile1 = this.addressImage;
    const imageFile2 = this.addressImage;
    const imageFile3 = this.addressImage;
    const imageFile4 = this.addressImage;
    const imageFile5 = this.addressImage;

    // img 1
    await this.drawRoundedImage(
      pdfDoc, 
      page, 
      imageFile1, 
      xCenterPosition - (imageWidth * 2.5) - (gap*2), 
      imgYPosition, 
      imageWidth, 
      imageHeight,
      10
    );
    // img 2
    await this.drawRoundedImage(
      pdfDoc, 
      page, 
      imageFile2, 
      xCenterPosition - (imageWidth * 1.5) - gap,
      imgYPosition, 
      imageWidth, 
      imageHeight,
      10
    );
    // img 3
    await this.drawRoundedImage(
      pdfDoc, 
      page, 
      imageFile3, 
      xCenterPosition - (imageWidth / 2),
      imgYPosition, 
      imageWidth, 
      imageHeight,
      10
    );
    // img 4
    await this.drawRoundedImage(
      pdfDoc, 
      page, 
      imageFile4, 
      xCenterPosition + (imageWidth / 2) + gap,
      imgYPosition, 
      imageWidth, 
      imageHeight,
      10
    );
    // img 5
    await this.drawRoundedImage(
      pdfDoc, 
      page, 
      imageFile5, 
      xCenterPosition + (imageWidth * 1.5) + (gap*2),
      imgYPosition, 
      imageWidth, 
      imageHeight,
      10
    );

    // Text: Reportage Photo
    this.drawAlignedText({
      page: page, 
      text: "REPORTAGE PHOTO", 
      x: xCenterPosition, 
      y: 120, 
      font: fontFamilyBold, 
      size: 32, 
      align: 'center', 
      textColor: this.COLOR.white, 
      // width: 0, 
      // height: 0, 
      // borderWidth: 1, 
      // borderColor: [0, 0, 0],
    });

    
    return pdfDoc;
  }
  async pageCalepinage(pdfPath, scenarioNbr, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Calepinage :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    // calepinage
    let imageWidth = 560;
    let imageHeight = 380;
    let xImg = xCenterPositionWithGap - (imageWidth/2);
    let yImg = 70;
    await this.drawRoundedImage(pdfDoc, page, this.cellpinageImage, xImg, yImg, imageWidth, imageHeight, 0);

    return pdfDoc;
  }
  async pageInvestissement(pdfPath, scenarioNbr, pageNumber, dataCompteurList){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });

    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Investissement :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })

    yPosition = yPosition - 20;
    // Scénario
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 50;
    // table title
    page.drawText("Récapitulatif des investissements, des fonctionnements et des productions solaires anuelles",{
      x: xStartLeft - 15,
      y: yPosition,
      font: fontFamilyBold,
      size: 13.5,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    });

    for (let i = 0; i < dataCompteurList.length; i++) {
      const compteur = dataCompteurList[i];
      yPosition = yPosition - 30;
      // table compteur detail
      yPosition = await this.drawTableCompteurInvest({
        page,
        x: xCenterPositionWithGap,
        y: yPosition,
        data: {
          num_compteur: compteur.num_compteur,
          installationsTotal: compteur.installationsTotal,
          installations: compteur.installations,
        },
        fontFamily, 
        fontFamilyItalic,
        fontFamilyBold,
        fontFamilyBoldItalic,
      });
    }

    // note
    yPosition = 80;
    page.drawText("•  ",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamily,
      size: 11,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    });
    const noteText = "Les futures installations ne sont pas éligibles à la prime d’investissement et à la prime d’intégration paysagère (conformément "+
    "au décret «JORF n°175» du 30/07/2022) car la puissance crête future des différentes centrales photovoltaïques dépassent "+
    "100 kWc. (Possibilité de subvention)";
    await this.drawMultiLineText({
      page, 
      text: noteText, 
      x: xStartLeft + 15,
      y: yPosition,
      font: fontFamily,
      size: 9.5,
      textColor: this.COLOR.darkBlue, 
      width: pageSize.width - 190,
    });

    return pdfDoc;
  }
  async pageFonctionnement(pdfPath, scenarioNbr, pageNumber, dataCompteurList){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Fonctionnement :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    });

    yPosition = yPosition - 35;
    // table title: Récapitulatif du coût de la maintenance sur 20 ans par site
    await this.drawAlignedText({
      page: page, 
      text: "Récapitulatif du coût de la maintenance sur 20 ans par site", 
      x: xCenterPositionWithGap, 
      y: yPosition, 
      font: fontFamilyBold, 
      size: 14, 
      align: 'center', 
      textColor: this.COLOR.darkBlue,
    });

    yPosition = yPosition - 30;
    // table 
    await this.drawTableFonctionnement({
      page,
      x: xCenterPositionWithGap,
      y: yPosition,
      data: dataCompteurList,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
    });

    // List Point Text
    await this.drawListPointText({
      page, 
      text: [
        'Maintenances préventive et curative des modules et des installations électriques',
        'Supervision des installations',
        'Nettoyages des modules et vérification des raccordements',
        'Assurance relative à l’installation',
        'Une visite réglementaire «Etablissement Recevant du Public (ERP)» relative à l’installation (en plus du contrôle annuel relative aux installations électriques de l’ERP, arrêté du 25 juin 1980 «règles de sécurité contre les risques d’incendie et de panique dans les ERP», code de la construction et de l’habitation «disposition applicables aux ERP»)',
      ], 
      x: xStartLeft, 
      y: 110, 
      font: fontFamily,
      size: 9.5,
      textColor: this.COLOR.darkBlue, 
      width: pageSize.width - 190,
    });

    return pdfDoc;
  }
  async pageProductionAnnuelle(pdfPath, scenarioNbr, pageNumber, mergedPdf,compteurs){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: `${pageNumber}`, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Production annuelle :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 40;
    // title chart: Ci-après l’estimation de la production solaire par site producteur
    await this.drawAlignedText({
      page: page, 
      text: "Ci-après l’estimation de la production solaire par site producteur", 
      x: xCenterPositionWithGap, 
      y: yPosition, 
      font: fontFamilyBold, 
      size: 14, 
      align: 'center', 
      textColor: this.COLOR.darkBlue,
    });

    yPosition = yPosition - 40;
    // subtitle chart: Estimation de production (kWh par an)
    await this.drawAlignedText({
      page: page, 
      text: "Estimation de production (kWh par an)", 
      x: xCenterPositionWithGap, 
      y: yPosition, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.black,
    });

    yPosition = yPosition - 20;
    // charts
    let functionReturn = {pdfDoc: pdfDoc, pageNumber: pageNumber};
    if(compteurs.length==1){
      // chart
      const widthChart = pageSize.width - xStartLeft - 50;
      const heightChart = 310;
      const xChart = xCenterPositionWithGap - (widthChart/2);
      const yChart = 60;
      try {
        const response = await axios({
          url: process.env.VUE_APP_URL_API_CLIENT + "generate_pie_chart/",
          method: "POST",
          responseType: "arraybuffer",
          data:{
            labels: [
              'Toiture', 
              'Ombrière',
              'Sol', 
            ],
            values: [
              compteurs[0].puissanceKWcToiture, 
              compteurs[0].puissanceKWcOmbriere, 
              compteurs[0].puissanceKWcSol,
            ],
            // center_value: '≈ 1 333 MWh/an',
          }
        });
    
        if (response.status === 200) {
          // Convert the image file to bytes
          const imageBytes = new Uint8Array(response.data);
          const image = await pdfDoc.embedPng(imageBytes);
          
          // Draw the image
          page.drawImage(image, {
            x: xChart,
            y: yChart,
            width: widthChart,
            height: heightChart,
          });
        }
      } catch (error) {
        console.error("Error fetching the chart image:", error);
      }
    }else{

      const formattedData = compteurs.map(item => {
        const values = [item.puissanceKWcToiture, item.puissanceKWcOmbriere, item.puissanceKWcSol];
        const total = values.reduce((sum, value) => sum + value, 0);
        const percentages = values.map(value => (value / total) * 100);
      
        return {
          label: item.Numero_Compteur,
          groups: [
            { label: "Toiture", percentage: percentages[0].toFixed(0) },
            { label: "Ombrière", percentage: percentages[1].toFixed(0) },
            { label: "Sol", percentage: percentages[2].toFixed(0) }
          ]
        };
      });
      // draw bars
      const barsRes = await this.drawBars({
        pdfDoc, page, mergedPdf, pdfPath,pageNumber,
        x: xStartLeft,
        y: yPosition,
        data: formattedData,
        fonts:{ fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic} ,
        barHeight: 20,
        gap: 20,
        textColor: rgb(this.COLOR.black[0],this.COLOR.black[1],this.COLOR.black[2]),
        barColors: [
          [0.27, 0.45, 0.77],
          [0.93, 0.49, 0.19],
          [0.65, 0.65, 0.65],
          [1.0, 0.75, 0.0],
          [0.36, 0.61, 0.84],
          [0.44, 0.68, 0.28],
          [0.15, 0.27, 0.47],
          [0.0, 0.70, 0.77]
        ],
        width: pageSize.width - xStartLeft - 100,
      });
      functionReturn = {pdfDoc: barsRes.pdfDoc, pageNumber: barsRes.pageNumber};
    }

    return functionReturn;
  }
  async pageRepartitionEnergieProduite(pdfPath, scenarioNbr, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Répartition de l’énergie PV produite :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 30;
    // consommation production info
    const consoProdRes = await this.drawConsoProdInfo({
      page, x: xStartLeft, y: yPosition, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic,
      data: [
        {
          label:'Production du site (PDL)',
          value: `${this.formatNumberOrText(this.pdfData.sommeProduction)} kWh`,
        },
        {
          label:'Consommation du site',
          value: `${this.formatNumberOrText(this.pdfData.sommeConsommation)} kWh`,
        },
        {
          label:'Autoconsommation individuelle',
          value: `${this.formatNumberOrText(this.pdfData.sommeAutoConsommerIndividuelle)} kWh`,
        },
        {
          label:'Surplus non consommé par le site',
          value: `${this.formatNumberOrText(this.pdfData.Reste_A_Vendre)} kWh`,
        }
      ],
    });

    yPosition = yPosition - 20 - consoProdRes.height;
    // text list
    yPosition = await this.drawListPointText({
      page, 
      text: [
        `Environ 100% de la production solaire est consommée localement par le site producteur –point de livraison (autoconsommation individuelle)`,
        `La réinjection de surplus au réseau est donc quasi inexistante.`,
      ], 
      x: xStartLeft, 
      y: yPosition, 
      font: fontFamily, 
      size: 9.5, 
      textColor: this.COLOR.darkBlue, 
      width: pageSize.width - xStartLeft - 35,
    })

    // chart 
    const widthChart = pageSize.width - xStartLeft - 80;
    const heightChart = 270;
    const xChart = xCenterPositionWithGap - (widthChart/2);
    const yChart = 45;
    try {
      const response = await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "generate_pie_chart/",
        method: "POST",
        responseType: "arraybuffer",
        data:{
          labels: [
            'Autoconsommation collective (ACC)', 
            'Autoconsommation individuelle (ACI)',
            'Surplus de production', 
          ],
          values: [
            this.pdfData.sommeAutoCollectif, 
            this.pdfData.sommeAutoConsommerIndividuelle, 
            this.pdfData.Reste_A_Vendre,
          ],
          // center_value: '≈ 1 333 MWh/an',
        }
      });
  
      if (response.status === 200) {
        // Convert the image file to bytes
        const imageBytes = new Uint8Array(response.data);
        const image = await pdfDoc.embedPng(imageBytes);
        
        // Draw the image
        page.drawImage(image, {
          x: xChart,
          y: yChart,
          width: widthChart,
          height: heightChart,
        });
      }
    } catch (error) {
      console.error("Error fetching the chart image:", error);
    }

    return pdfDoc;
  }
  async pageDetailCompteur(pdfPath, scenarioNbr, pageNumber, dataCompteur,mergedPdf){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: `${pageNumber}`, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });

    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Detail Compteur :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })

    yPosition = yPosition - 20;
    // Scénario
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 50;
    // desciption
    page.drawText("Récapitulatif des poductions et des consommations solaires de "+ dataCompteur.numCompteur,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 13.5,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    });

    yPosition = yPosition - 30;
    // table compteur detail
    const detailCompteurTableRes = await this.drawTableDetailCompteur({
      pdfDoc, mergedPdf, page, pdfPath, pageNumber,
      x: xCenterPositionWithGap,
      y: yPosition,
      data: dataCompteur,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
    });

    return { pdfDoc: detailCompteurTableRes.pdfDoc, pageNumber: detailCompteurTableRes.pageNumber };
  }
  async pageSimulationEconomique(pdfPath, scenarioNbr, pageNumber, mergedPdf){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: `${pageNumber}`, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Simulation économique :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 30;
    // consommation production info
    const consoProdRes = await this.drawConsoProdInfo({
      page, x: xStartLeft, y: yPosition, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic,
      data: [
        {
          label:'Production du site (PDL)',
          value: `${this.formatNumberOrText(this.pdfData.sommeProduction)} kWh`,
        },
        {
          label:'Consommation du site',
          value: `${this.formatNumberOrText(this.pdfData.sommeConsommation)} kWh`,
        },
        {
          label:'Autoconsommation individuelle',
          value: `${this.formatNumberOrText(this.pdfData.sommeAutoConsommerIndividuelle)} kWh`,
        },
        {
          label:'Surplus non consommé par le site',
          value: `${this.formatNumberOrText(this.pdfData.Reste_A_Vendre)} kWh`,
        }
      ],
    });

    yPosition = yPosition - 20 - consoProdRes.height;
    // text list
    yPosition = await this.drawListPointText({
      page, 
      text: [
        `Hypothèse du prix TTC du kWh : 0,12€ (Retour d’expérience en tarifs C2 & C3)`,
        `L’augmentation du prix du kWh est estimée à 10%(à partir de 2025) par an sur la durée de l’exploitation du parc photovoltaïque.`,
        `La vente du surplus de production est estimée à 7€ (HT) par kWh produit en photovoltaïque. (Retour d’expérience – offres fournisseurs)`,
        `L’augmentation du prix de la maintenance est fixée à 2% par an.`,
      ], 
      x: xStartLeft, 
      y: yPosition, 
      font: fontFamily, 
      size: 9.5, 
      textColor: this.COLOR.darkBlue, 
      width: pageSize.width - xStartLeft - 35,
    })

    yPosition = yPosition - 20;
    // table  { pdfDoc: pdfDocLocal, page: pageLocal, y: yCurrent }
    const tableSimulationEcoRes = await this.drawTableSimulationEco({
      pdfDoc, mergedPdf, page, pdfPath, pageNumber,
      x: xStartLeft, y: yPosition, 
      fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic, 
    });

    return {pdfDoc: tableSimulationEcoRes.pdfDoc, pageNumber: tableSimulationEcoRes.pageNumber};
  }
  async pageEstimationFactureEnergie(pdfPath, scenarioNbr, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Estimation - Facture énergie :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 32;
    // chart title
    await this.drawAlignedText({
      page: page, 
      text: "Simulation de la facture (avant / après PV)", 
      x: xCenterPositionWithGap, 
      y: yPosition, 
      font: fontFamilyBold, 
      size: 14, 
      align: 'center', 
      textColor: this.COLOR.darkBlue,
    });

    // chart
    yPosition = yPosition - 20;
    const xChart = xStartLeft;
    const yChart = 50;
    const widthOfChart = pageSize.width - xStartLeft - 40;
    const heightOfChart = yPosition - yChart - 50;
    try {
      const response = await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "generate_line_chart/",
        method: "POST",
        responseType: "arraybuffer",
        data:{
          chart_values: {
            x: [1, 2, 3, 4, 5, 6, 7, 8],
            y1: [10, 1900000, 2000000, 2100000, 2200000, 2300000, 2400000, 2500000],
            y2: [2000000, 2100000, 2200000, 2300000, 2400000, 2500000, 2600000, 2700000],
          }
        }
      });
  
      if (response.status === 200) {
        // Convert the image file to bytes
        const imageBytes = new Uint8Array(response.data);
        const image = await pdfDoc.embedPng(imageBytes);
        
        // Draw the image
        page.drawImage(image, {
          x: xChart,
          y: yChart,
          width: widthOfChart,
          height: heightOfChart,
        });
      }
    } catch (error) {
      console.error("Error fetching the chart image:", error);
    }


    // info Investissement TTC
    await this.drawAlignedText({
      page: page, 
      text: `Investissement TTC`, 
      x: 180, 
      y: 410, 
      font: fontFamilyBold, 
      size: 10, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });
    await this.drawAlignedText({
      page: page, 
      text: `${this.formatNumberOrText(1432818, 2)} €`, 
      x: 180, 
      y: 390, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.green,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });
    // info RSI 
    await this.drawAlignedText({
      page: page, 
      text: `RSI : ${this.rsiAns} ans`, 
      x: 180, 
      y: 360, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });
    await this.drawAlignedText({
      page: page, 
      text: `${this.formatNumberOrText(this.rsi, 2)} €`, 
      x: 180, 
      y: 340, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.green,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });

    // info Coût de la maintenance (par an) Taux d'inflation annuelle
    await this.drawWrappedMultiLineText({
      page: page, 
      text: `Coût de la maintenance (par an) Taux d'inflation annuelle : 2`, 
      x: 500, 
      y: 400, 
      font: fontFamilyBold, 
      size: 8, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 150,
      height: 25,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });
    await this.drawAlignedText({
      page: page, 
      text: `${this.formatNumberOrText(19262.99, 2)} €`, 
      x: 500, 
      y: 380, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.green,
      width: 150,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });

    // Taux d’autoconsommation ≈ 100%
    await this.drawAlignedText({
      page: page, 
      text: `Taux d’autoconsommation ~= 100%`, 
      x: 310, 
      y: 400, 
      font: fontFamilyBold, 
      size: 10, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 180,
      height: 30,
      borderWidth: 1,
      borderColor: this.COLOR.darkGrey,
      bgColor: this.COLOR.lightYellow,
    });

    // Taux de couverture ≈ 8%
    await this.drawAlignedText({
      page: page, 
      text: `Taux de couverture ~= 8%`, 
      x: 310, 
      y: 360, 
      font: fontFamilyBold, 
      size: 10, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 180,
      height: 30,
      borderWidth: 1,
      borderColor: this.COLOR.darkGrey,
      bgColor: this.COLOR.lightYellow,
    });

    return pdfDoc;
  }
  async pageRetourInvestissement(pdfPath, scenarioNbr, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let yPosition = pageSize.height - 40;
    // title
    page.drawText("Retour Sur Investissement (RSI) :",{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    yPosition = yPosition - 20;
    // Scénario number
    page.drawText("Scénario "+scenarioNbr,{
      x: xStartLeft,
      y: yPosition,
      font: fontFamilyBold,
      size: 16,
      color: rgb(this.COLOR.skyBlue[0], this.COLOR.skyBlue[1], this.COLOR.skyBlue[2]),
    })

    yPosition = yPosition - 35;
    // chart title: Recettes cumulées de l’installation
    await this.drawAlignedText({
      page: page, 
      text: "Recettes cumulées de l’installation", 
      x: xCenterPositionWithGap, 
      y: yPosition, 
      font: fontFamilyBold, 
      size: 14, 
      align: 'center', 
      textColor: this.COLOR.darkBlue,
    });

    // chart
    yPosition = yPosition - 20;
    const xChart = xStartLeft;
    const yChart = 50;
    const widthOfChart = pageSize.width - xStartLeft - 40;
    const heightOfChart = yPosition - yChart;
    try {
      const response = await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "generate_bar_chart/",
        method: "POST",
        responseType: "arraybuffer",
        data:{
          chart_values: {
            x: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
            y: [-2000000, -1500000, -1000000, -500000, 300000, 500000, 1000000, 1500000, 2000000, 2500000, 
              3000000, 3500000, 4000000, 4500000, 5000000, 5500000, 6000000, 6500000, 7000000, 7500000],
          }
        }
      });
  
      if (response.status === 200) {
        // Convert the image file to bytes
        const imageBytes = new Uint8Array(response.data);
        const image = await pdfDoc.embedPng(imageBytes);
        
        // Draw the image
        page.drawImage(image, {
          x: xChart,
          y: yChart,
          width: widthOfChart,
          height: heightOfChart,
        });
      }
    } catch (error) {
      console.error("Error fetching the chart image:", error);
    }


    // info RSI 
    await this.drawAlignedText({
      page: page, 
      text: `RSI : ${this.rsiAns} ans`, 
      x: xStartLeft + 80, 
      y: yPosition - 40, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.black,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });
    await this.drawAlignedText({
      page: page, 
      text: `${this.formatNumberOrText(this.rsi, 2)} €`, 
      x: xStartLeft + 80, 
      y: yPosition - 60, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.green,
      width: 110,
      height: 20,
      borderWidth: 1,
      borderColor: this.COLOR.darkBlue,
    });

    return pdfDoc;
  }
  async pageSyntheseRecapitulatif(pdfPath, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xCenterPositionWithGap,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });

    let yStart = pageSize.height - 40;
    // title
    page.drawText("Synthèse :",{
      x: xStartLeft,
      y: yStart,
      font: fontFamilyBold,
      size: 35,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    
    yStart = yStart - 60;
    // text: Récapitulatif des scenarios
    this.drawAlignedText({
      page: page, 
      text: "Récapitulatif de scenario", 
      x: xCenterPosition + 41, 
      y: yStart, 
      font: fontFamilyBold, 
      size: 14, 
      align: 'center', 
      textColor: this.COLOR.darkBlue2,
    });

    yStart = yStart - 30;
    // Table Recapitulatif
    const newYPosition = await this.drawTableRecapitulatif({
      page,
      x: xCenterPositionWithGap,
      y: yStart,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
    });

    yStart = newYPosition - 50; // move cursor down for "drawRectangleRecapInfo"
    // Rectangle TAC TAP RSI
    this.drawRectangleRecapInfo({ page, x: xStartLeft, y: yStart, font: fontFamily});

    return pdfDoc;
  }
  async pageSynthese(pdfPath, syntheseData, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xStartLeft,
    } = await this.init(pdfPath);

    let yStart = pageSize.height - 40;
        
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    
    // title
    page.drawText("Synthèse :",{
      x: xStartLeft,
      y: yStart,
      font: fontFamilyBold,
      size: 35,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    
    // scenario
    yStart = yStart - 70;
    const newYPosition = await this.drawMultiLineText({
      page: page, 
      text: syntheseData.title, 
      x: xStartLeft,
      y: yStart, 
      font: fontFamilyBold, 
      size: 13, 
      align: 'left', 
      lineHeight: 13 * 1.2,
      textColor: this.COLOR.lightBlue2, 
      width: pageSize.width - 120, 
    });
    yStart = newYPosition - 19;
    // sub senario
    page.drawText(syntheseData.subtitle,{
      x: xStartLeft,
      y: yStart,
      font: fontFamilyItalic,
      size: 10,
      lineHeight: 10*1.63,
      color: rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
    })
    
    // text
    let text = `• Taux d’autoconsommation individuelle & collective : ${syntheseData.autoConsoIndivCollective}\n`+
    `• Taux de revente du surplus : ${syntheseData.tauxReventeSurplus}\n`+
    `• Taux de couverture des besoins énergétiques (globales) : ${syntheseData.tauxBesoinEnergitiqueGlobale}\n`+
    `• Economie énergétique à 6 ans : ${syntheseData.economie6}\n`+
    `• Economie énergétique à 9 ans : ${syntheseData.economie9}\n`+
    `• Economie énergétique à 12 ans : ${syntheseData.economie12}\n`+
    `• Retour Sur Investissement (RSI) moyen = ${syntheseData.rsiAns} (sans subventions)`;
    
    page.drawText(text,{
      x: xStartLeft + 7,
      y: pageSize.height - 195,
      font: fontFamilyBold,
      size: 14,
      lineHeight: 16*2.5,
      color: rgb(this.COLOR.darkBlue2[0], this.COLOR.darkBlue2[1], this.COLOR.darkBlue2[2]),
    });

    // ********** shape **********
    const svgPath = " M76.120872,764.000000   C76.120880,651.172791 76.120758,538.845520 76.120941,426.518311   C76.120956,416.290833 76.692635,415.505066 86.630936,411.825195   C87.378090,411.548584 88.048134,411.063751 89.091667,410.490051   C87.126740,409.830017 85.537766,409.366272 84.001228,408.767883   C77.615936,406.281311 76.121330,404.073059 76.121292,397.240326   C76.120644,277.080200 76.085609,156.919998 76.244034,36.760078   C76.250664,31.731298 74.817001,29.374296 69.905052,28.884365   C56.011532,27.498587 42.131302,25.979313 28.236769,24.604244   C25.814022,24.364477 23.347181,24.570263 20.646067,24.570263   C20.646067,21.246447 20.646067,18.663929 20.646067,16.191824   C28.832167,16.191824 36.817211,15.571710 44.664692,16.345921   C54.894901,17.355207 65.054146,19.273802 75.159409,21.236349   C77.953888,21.779064 80.556541,23.706968 83.005074,25.358351   C83.629242,25.779312 83.346573,27.571217 83.441284,28.736422   C83.473984,29.138773 83.267700,29.586075 83.375595,29.952475   C83.907127,31.757551 85.010597,33.542019 85.011787,35.334362   C85.091156,154.827820 85.124901,274.321381 84.943039,393.814606   C84.935204,398.962921 86.676819,401.279938 91.319321,401.743958   C106.197586,403.230957 121.088173,404.595490 135.977386,405.970795   C137.436798,406.105591 138.919449,405.988739 140.699905,405.988739   C140.699905,409.070648 140.699905,411.822327 140.699905,415.925995   C134.222443,415.925995 127.604263,415.455200 121.079460,416.035004   C110.987579,416.931824 100.967369,418.611603 90.900902,419.828186   C86.132393,420.404449 84.968285,422.861847 84.973747,427.551392   C85.113060,547.211365 85.083817,666.871643 85.083176,786.531799   C85.083130,795.996765 84.117882,797.549133 74.813316,800.295959   C57.221375,805.489380 39.101250,805.690979 20.673859,806.023193   C20.673859,802.941467 20.673859,800.346863 20.673859,797.362488   C28.945726,796.907349 37.218910,796.773743 45.415833,795.913574   C54.165867,794.995239 62.836475,793.338013 71.556816,792.110352   C75.263870,791.588501 76.362465,789.678284 76.208298,785.995789   C75.908806,778.841797 76.120758,771.666504 76.120872,764.000000  z";
    page.drawSvgPath(svgPath, {
        x: 417,
        y: 250,
        color: rgb(this.COLOR.greenGrass[0], this.COLOR.greenGrass[1], this.COLOR.greenGrass[2]),
        borderColor: rgb(this.COLOR.greenGrass[0], this.COLOR.greenGrass[1], this.COLOR.greenGrass[2]),
        borderWidth: 3,
        scale:0.15,
    });
    // ********** total economie **********
    page.drawText("Total économie en 20 ans : 9,5 M€",{
      x: 460,
      y: 190,
      font: fontFamilyBold,
      size: 13,
      color: rgb(this.COLOR.greenGrass[0], this.COLOR.greenGrass[1], this.COLOR.greenGrass[2]),
    })
    page.drawText("+10% d’augmentation du prix du kWh TTC par an",{
      x: 460,
      y: 178,
      font: fontFamilyItalic,
      size: 10,
      color: rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
    })

    return pdfDoc;
  }
  async pagePlanning(pdfPath, pageNumber){
    const {
      pdfDoc,
      pages,
      page,
      pageSize,
      fontFamily, 
      fontFamilyItalic,
      fontFamilyBold,
      fontFamilyBoldItalic,
      xCenterPosition,
      yCenterPosition,
      xStartLeft,
    } = await this.init(pdfPath);
    
    // title
    page.drawText("Planning :",{
      x: xStartLeft,
      y: pageSize.height - 40,
      font: fontFamilyBold,
      size: 34,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })
    // page number
    this.drawAlignedText({
      page: page, 
      text: pageNumber, 
      x: pageSize.width - 48, 
      y: 35, 
      font: fontFamilyBold, 
      size: 12, 
      align: 'center', 
      textColor: this.COLOR.darkBlue, 
      width: 25, 
    });
    let text = "• 06 mars Présentation des principes & investissements\n"+
    "• En attente de l’accord (OTV) d’accès aux données du gestionnaire de réseau\n"+
    "  (consommations jour par jour reçues –nécessité d’avoir les consommations heure\n"+
    "  par heure)\n"+
    "• 15 mars : Envoi de la comparaison entre MPGP –Marché travaux énergétique\n"+
    "• 19 avril : Envoi de la Prospective Financière et du choix de la procédure (avec\n"+
    "  critères du Règlement de Consultation)\n"+
    "• 26 avril : Echanges & décisions\n"+
    "• 27 mai : Bureau syndical\n"+
    "• 24 juin : Conseil syndical\n"+
    "• Juillet : Elaboration du Dossier de Consultation des Entreprises Août à janvier\n"+
    "  (2025) : Mise en concurrence\n"+
    "• Février (2025) : Mise au point & démarrage du marché Planning travaux : 6 mois\n";
    // text
    page.drawText(text,{
      x: xStartLeft + 15,
      y: pageSize.height - 120,
      font: fontFamilyBoldItalic,
      size: 13,
      lineHeight: 13*1.63,
      color: rgb(this.COLOR.darkBlue[0], this.COLOR.darkBlue[1], this.COLOR.darkBlue[2]),
    })

    return pdfDoc;
  }

  // --------------------- helpers ------------------------
  async drawConsoProdInfo({page, x=0, y=0, data,fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    const w1 = 120;
    const w2 = 80;
    const height = 15;
    let yCurrent = y;
    for (let i = 0; i < data.length; i++) {
      const line = data[i];
      yCurrent = yCurrent-height;
      // label
      await this.drawAlignedText({
        page, 
        text: line.label, 
        x: x, 
        y: yCurrent, 
        font: fontFamilyBoldItalic, 
        size: 7, 
        align: 'center', 
        textColor: this.COLOR.black, 
        width: w1,
        height: height, 
        borderWidth:1, 
        borderColor: this.COLOR.black,
        padding: 2,
      })
      // value
      await this.drawAlignedText({
        page, 
        text: line.value, 
        x: x + w1, 
        y: yCurrent, 
        font: fontFamily, 
        size: 8, 
        align: 'right', 
        textColor: this.COLOR.black, 
        width: w2,
        height: height, 
        borderWidth:1, 
        borderColor: this.COLOR.black,
        padding: 2,
      })
    }
    return { height: height*data.length }
  }
  drawRectangleRecapInfo({page, x=0, y=0, font}){
    page.drawRectangle({
      x: x,
      y: y,
      width: 297,
      height: 37,
      borderWidth: 0.5,
      borderColor: rgb(this.COLOR.black[1], this.COLOR.black[1], this.COLOR.black[1]),
      borderOpacity: 0.75,
    });
    // TAC : Taux d'Auto-Consommation
    page.drawText("*",{
      x: x+6,
      y: y+26,
      font: font,
      size: 10,
      color: rgb(this.COLOR.red[0], this.COLOR.red[1], this.COLOR.red[2]),
    });
    page.drawText("TAC : Taux d'Auto-Consommation",{
      x: x+10,
      y: y+26,
      font: font,
      size: 8,
      color: rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
    });
    // TAC : Taux d'Auto-Production ou de couverture des dépenses énergétiques
    page.drawText("*",{
      x: x+6,
      y: y+16,
      font: font,
      size: 10,
      color: rgb(this.COLOR.red[0], this.COLOR.red[1], this.COLOR.red[2]),
    });
    page.drawText("TAP : Taux d'Auto-Production ou de couverture des dépenses énergétiques",{
      x: x+10,
      y: y+16,
      font: font,
      size: 8,
      color: rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
    });
    // RSI : Retour sur Investissement
    page.drawText("*",{
      x: x+6,
      y: y+6,
      font: font,
      size: 10,
      color: rgb(this.COLOR.red[0], this.COLOR.red[1], this.COLOR.red[2]),
    });
    page.drawText("RSI : Retour sur Investissement",{
      x: x+10,
      y: y+6,
      font: font,
      size: 8,
      color: rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
    });
  }
  async drawLegend(page, legendItems, x, y, font, fontSize, textColor) {
    const itemHeight = fontSize + 4;
    let xCurrent = x;
    let yCurrent = y;
    
    legendItems.forEach(item => {
      const widthOfLabel = font.widthOfTextAtSize(item.label, fontSize);
      
      // Draw color square
      const width_rect = fontSize/1.5;
      const height_rect = fontSize/1.5;
      page.drawRectangle({
        x: xCurrent,
        y: yCurrent,
        width: width_rect,
        height: height_rect,
        color: rgb(item.color[0],item.color[1],item.color[2]),
      });
      
      // Draw label
      page.drawText(item.label, {
        x: xCurrent + width_rect + 5,
        y: yCurrent,
        size: fontSize,
        font: font,
        color: textColor ? rgb(textColor[0], textColor[1], textColor[2]) : rgb(this.COLOR.black[0], this.COLOR.black[1], this.COLOR.black[2]),
      });
      
      xCurrent = xCurrent + widthOfLabel + 20;
    });
  
    return yCurrent - itemHeight;
  }
  async drawBars({ pdfDoc, page, mergedPdf, pageNumber, pdfPath, data, x, y, barHeight, gap, barColors, textColor, width, fonts}) {
    const { fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic} = fonts;
    let pdfDocLocal = pdfDoc;
    let pageLocal = page;
    let pageNumberLocal = pageNumber;
    let labelFont = fontFamilyBold;
    let font = fontFamilyBold;
    let fontSize = 10;
    let legendFontSize = 8;
    let yCurrent = y;

    // Draw legend
    const legendItems = [
      { label: "Toitures", color: barColors[0] },
      { label: "Ombrière", color: barColors[1] },
      { label: "Sol", color: barColors[2] },
    ];

    // const widthOfAllLegends = legendItems.reduce((acc,val)=>{
    //   const width = fontFamily.widthOfTextAtSize(val.label, legendFontSize);
    //   return acc + width;
    // },0)

    const pageSize = pageLocal.getSize();
    const xLegends = pageSize.width/2;

    yCurrent = await this.drawLegend(pageLocal, legendItems, xLegends, yCurrent, fontFamily, legendFontSize, this.COLOR.black);
    
    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      const { label, groups } = item;  // groups is an array of { label, percentage } objects
      let xCurrent = x;
      
      yCurrent =  yCurrent - barHeight
      if(yCurrent<60){
        mergedPdf = await this.addPagesToPdf(mergedPdf, pdfDocLocal);
        const newPDFRes = await this.init(pdfPath);
        pdfDocLocal = newPDFRes.pdfDoc;
        pageLocal = newPDFRes.page;
        labelFont = newPDFRes.fontFamilyBold;
        font = newPDFRes.fontFamilyBold;
        yCurrent = newPDFRes.pageSize.height - 40;
        pageNumberLocal = pageNumberLocal + 1;
        // page number
        this.drawAlignedText({
          page: pageLocal, 
          text: `${pageNumberLocal}`, 
          x: newPDFRes.pageSize.width - 48, 
          y: 35, 
          font: font, 
          size: 12, 
          align: 'center', 
          textColor: this.COLOR.darkBlue, 
          width: 25, 
        });
      }
      // Draw main label "compteur"
      pageLocal.drawText(label, {
        x: xCurrent,
        y: yCurrent + barHeight / 4,
        size: fontSize,
        font: labelFont,
        color: rgb(this.COLOR.greenGrassDark[0],this.COLOR.greenGrassDark[1],this.COLOR.greenGrassDark[2]),
      });
  
      const widthOfLabel = labelFont.widthOfTextAtSize(label, fontSize);
      xCurrent = xCurrent + widthOfLabel + 10;

      // Draw grouped bars within the main bar
      let cumulativeWidth = 0;
      groups.forEach((group, groupIndex) => {
        const { label: groupLabel, percentage } = group;
        const barWidth = (width - 50) * (percentage / 100);

        const currentBackground = barColors[groupIndex % barColors.length]

        this.drawAlignedText({
          page: pageLocal, 
          text: `${percentage}%`, 
          x: xCurrent + cumulativeWidth,
          y: yCurrent,
          font: font, 
          size: fontSize, 
          align: 'center', 
          textColor: this.COLOR.black, 
          width: barWidth, 
          height: barHeight,
          bgColor: currentBackground,
        })
  
        // // Draw sub-bar
        // pageLocal.drawRectangle({
        //   x: xCurrent + cumulativeWidth,
        //   y: yCurrent,
        //   width: barWidth,
        //   height: barHeight,
        //   color: barColors[groupIndex % barColors.length],
        // });
  
        // // Draw percentage text within sub-bar
        // if(percentage>=1){
        //   pageLocal.drawText(`${percentage}%`, {
        //     x: xCurrent + cumulativeWidth + barWidth / 2 - 10,
        //     y: yCurrent + barHeight / 4,
        //     size: fontSize,
        //     font: font,
        //     color: textColor,
        //   });
        // }
  
        cumulativeWidth += barWidth;
      });

      yCurrent =  yCurrent - gap; // vertical gap between bars
    }

    return { pdfDoc: pdfDocLocal, page: pageLocal, y: yCurrent, pageNumber: pageNumberLocal }
  }


  // --------------------- table --------------------------
  async drawTableDetailCompteur({pdfDoc, page, pdfPath, mergedPdf, pageNumber, x=0, y=0, data, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    const widthCol1 = 100;
    const widthCol2 = 77;
    const widthCol3 = 77;
    const widthCol4 = 77;
    const widthCol5 = 77;
    const widthCol6 = 77;
    const widthCol7 = 77;
    const widthCol8 = 77;
    const headerBgColor = this.COLOR.blue100;
    const bodyBgColor = this.COLOR.white;
    const headerFontSize = 8;
    const bodyFontSize = 8;
    const headerRowHeight = 40;
    const rowHeight = 20;
    let pdfDocLocal = pdfDoc;
    let pageLocal = page;
    let pageNumberLocal = pageNumber;

    const detail_prod_conso = data.detail_prod_conso ? Object.values(data.detail_prod_conso) : [];

    const headers = [
      { text: "PDL", width: widthCol1, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Production", width: widthCol2, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Consommation", width: widthCol3, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Auto Consommation Individuelle", width: widthCol4, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Auto Consommation Collectif Donner", width: widthCol5, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Surplus", width: widthCol6, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Auto Consommation Collectif Pris", width: widthCol7, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
    ];
    const widthOfTable = headers.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.width;
    }, 0);
    const body = [
      [
        { text: `${data.numCompteur}`, width: widthCol1, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.prod,2)}`, width: widthCol2, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.conso,2)}`, width: widthCol3, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.ACI,2)}`, width: widthCol4, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.donner_total,2)}`, width: widthCol5, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.sommeSurplus,2)}`, width: widthCol6, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.ACC_pris,2)}`, width: widthCol7, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Récapitulatif de poduction", width: widthOfTable, height: rowHeight, font: fontFamilyBold, textColor: this.COLOR.white, bgColor: this.COLOR.blue600, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "", width: widthCol1, height: rowHeight, font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.blue200, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "Donner a", width: (widthOfTable-widthCol1)/2, height: rowHeight, font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.blue200, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "Pris de", width: (widthOfTable-widthCol1)/2, height: rowHeight, font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.blue200, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      // Table data rows
      ...Array.from(detail_prod_conso, (el, i) => [
        { text: `${el.numCompteur}`, width: widthCol1, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(el.donner_a, 2)}`, width: (widthOfTable-widthCol1)/2, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(el.pris_de, 2)}`, width: (widthOfTable-widthCol1)/2, height: rowHeight, textColor: this.COLOR.black, bgColor: bodyBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      ]),
    ];

    
    let xStartTable = x - (widthOfTable/2);
    let yTableCurrent = y - headerRowHeight;

    // draw header
    await this.drawMultiLineTableRow({
      page: pageLocal, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: headerFontSize,
      font: fontFamilyBold,
      row: headers,
    });

    // draw table rows
    for (let i = 0; i < body.length; i++) {
      const row = body[i];
      yTableCurrent = yTableCurrent - rowHeight; // move down
      if(yTableCurrent<60){
        mergedPdf = await this.addPagesToPdf(mergedPdf, pdfDocLocal);
        const newPDFRes = await this.init(pdfPath);
        pdfDocLocal = newPDFRes.pdfDoc;
        pageLocal = newPDFRes.page;
        yTableCurrent = newPDFRes.pageSize.height - 40;
        pageNumberLocal = pageNumberLocal + 1;
        // page number
        this.drawAlignedText({
          page: pageLocal, 
          text: `${pageNumberLocal}`, 
          x: newPDFRes.pageSize.width - 48, 
          y: 35, 
          font: fontFamilyBold, 
          size: 12, 
          align: 'center', 
          textColor: this.COLOR.darkBlue, 
          width: 25, 
        });
      }
      await this.drawMultiLineTableRow({
        page: pageLocal, 
        x: xStartTable, 
        y: yTableCurrent, 
        size: bodyFontSize,
        font: fontFamily,
        row: row,
      });
    }

    return { pdfDoc: pdfDocLocal, pageNumber: pageNumberLocal, page: pageLocal, y: yTableCurrent };
  }
  async drawTableSimulationEco({pdfDoc, mergedPdf, pdfPath, pageNumber, page, x=0, y=0, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    const fontSize = 7;
    const rowHeaderHeight = 35;
    const rowHeight = 15;
    const widthCol = 75;
    let pdfDocLocal = pdfDoc;
    let pageLocal = page;
    let font = fontFamilyBold;
    let pageNumberLocal = pageNumber;
    // Define table data
    const tableData = [
      // First row (Header)
      [
        { text: "ACI", width: widthCol, height: rowHeight, bgColor: this.COLOR.green,},
        { text: "1 331 836 kWh", width: widthCol, height: rowHeight, bgColor: this.COLOR.green, },
        { text: "ACC", width: widthCol, height: rowHeight, bgColor: this.COLOR.greenGrass300, },
        { text: "0 kWh", width: widthCol, height: rowHeight, bgColor: this.COLOR.greenGrass300, },
        { text: "Taux Taxes ACC", width: widthCol, height: rowHeight, bgColor: this.COLOR.grey200, },
        { text: "26%", width: widthCol, height: rowHeight, bgColor: this.COLOR.grey200, },
      ],
      // Second row (Subheader)
      [
        { text: "Investissement", width: widthCol, height: rowHeight, align: 'center', bgColor: this.COLOR.blue100, borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "TTC hors subventions", width: (widthCol*2), height: rowHeight, align: 'center', bgColor: this.COLOR.blue400, borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "1 668 024 €", width: widthCol, height: rowHeight, align: 'center', bgColor: this.COLOR.blue400, borderWidth: 1, borderColor: this.COLOR.black, },
      ],
      // Third row (Header info)
      [
        { text: "Analyse Energétique", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "-", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "15 198 079 kWh", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "13 999 787 KWH", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "0 kWh", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "542 Kwh", width: widthCol, height: rowHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
      ],
      // Fourth row (Header)
      [
        { text: "-", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Prix du kWh annuelle (€) TTC", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Facture Energie (€) TTC sans PV", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Facture Energie (€) TTC avec PV", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Autoconsommation collective (€) TTC", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Vente du surplus de production (€) TTC", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Cout de la maintenance (€) TTC", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: "Delta €", width: widthCol, height: rowHeaderHeight, bgColor: [0.9, 0.9, 0.9], textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
      ],
      // Table data rows
      ...Array.from(this.simulationEcoList, (el, i) => [
        { text: (i + 1).toString(), width: widthCol, height: rowHeight, bgColor: [0.3, 0.6, 0.9], textColor: [1, 1, 1], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.prixDuKWhAnnuelleTTC, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.factureEnergieTTCSansPV, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.factureEnergieTTCAvecPV, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.autoconsommationCollectiveTTC, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.venteDuSurplusDeProductionTTC, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.coutDeLaMaintenanceTTC, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(el.delta, 2)}`, width: widthCol, height: rowHeight, bgColor: [0.3, 0.6, 0.9], textColor: [1, 1, 1], borderWidth: 1, borderColor: this.COLOR.black, },
      ]),
      // RSI row
      [
        { text: `RSI: ${this.rsiAns} ans`, width: widthCol, height: rowHeight, bgColor: [0.3, 0.6, 0.9], textColor: [1, 1, 1], borderWidth: 1, borderColor: this.COLOR.black, },
        { text: `${this.formatNumberOrText(this.rsi, 2)}`, width: widthCol, height: rowHeight, textColor: [0, 0, 0], borderWidth: 1, borderColor: this.COLOR.black, },
      ],
    ];

    let xCurrent = x;
    let yCurrent = y;

    // Draw the table
    for (let row of tableData) {
      yCurrent = yCurrent - row[0].height; // Adjust Y position for the next row
      if(yCurrent<60){
        mergedPdf = await this.addPagesToPdf(mergedPdf, pdfDocLocal);
        const newPDFRes = await this.init(pdfPath);
        pdfDocLocal = newPDFRes.pdfDoc;
        pageLocal = newPDFRes.page;
        font = newPDFRes.fontFamilyBold;
        yCurrent = newPDFRes.pageSize.height - 40;
        pageNumberLocal = pageNumberLocal + 1;
        // page number
        this.drawAlignedText({
          page: pageLocal, 
          text: `${pageNumberLocal}`, 
          x: newPDFRes.pageSize.width - 48, 
          y: 35, 
          font: font, 
          size: 12, 
          align: 'center', 
          textColor: this.COLOR.darkBlue, 
          width: 25, 
        });
      }
      await this.drawMultiLineTableRow({
        page: pageLocal,
        x: xCurrent,
        y: yCurrent,
        size: fontSize,
        font: font,
        row: row,
        paddingHorizontal: 2,
      });
    }

    return { pdfDoc: pdfDocLocal, pageNumber: pageNumberLocal, page: pageLocal, y: yCurrent }
  }
  async drawTableFonctionnement({page, x=0, y=0, data, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    if(!data) return; // do nothing
    const colWidth = 70;
    const colOneWidth = 40;

    // ----------- compteur row -----------
    const compteurRowHeight = 20;
    const compteurRow = [{ text: "", width: colOneWidth, height: compteurRowHeight  }];
    for (let i = 0; i < data.length; i++) {
      const compteur = data[i];
      const colsLength = compteur.Opex.length;
      compteurRow.push({ 
        text: compteur.Numero_Compteur.toString(), 
        width: colWidth*colsLength, 
        height: compteurRowHeight,
        textColor: this.COLOR.darkBlue2,
        borderWidth: 1,
        borderColor: this.COLOR.grey200,
      })
    }
    const widthOfTable = compteurRow.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.width;
    }, 0); // calculate width to center the table
    let xStartTable = x - (widthOfTable/2);
    let yTableCurrent = y - compteurRowHeight;
    const compteurRowRes = await this.drawMultiLineTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: 9,
      font: fontFamilyBold,
      row: compteurRow,
    });

    // ----------- title row -----------
    const titleRowHeight = 13;
    const titleRow = [{ text: "", width: colOneWidth, height: titleRowHeight  }];
    for (let indexCompteur = 0; indexCompteur < data.length; indexCompteur++) {
      const compteur = data[indexCompteur];
      for (let indexOpex = 0; indexOpex < compteur.Opex.length; indexOpex++) {
        const item = compteur.Opex[indexOpex];
        titleRow.push({ 
          text: item.mode.toString(), 
          width: colWidth, 
          height: titleRowHeight, 
          bgColor: this.COLOR.blue100 
        })
      }
    }
    yTableCurrent = yTableCurrent - titleRowHeight;
    const titleRowRes = await this.drawMultiLineTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: 7,
      font: fontFamily,
      row: titleRow,
    });
    
    // ----------- puissance row -----------
    const puissanceRowHeight = 13;
    const puissanceRow = [{ text: "kWc", width: colOneWidth, height: puissanceRowHeight  }];
    for (let indexCompteur = 0; indexCompteur < data.length; indexCompteur++) {
      const compteur = data[indexCompteur];
      for (let indexOpex = 0; indexOpex < compteur.Opex.length; indexOpex++) {
        const item = compteur.Opex[indexOpex];
        puissanceRow.push({ 
          text: item.puissanceKWc.toString(), 
          width: colWidth, 
          height: puissanceRowHeight
        })
      }
    }
    yTableCurrent = yTableCurrent - puissanceRowHeight;
    const puissanceRowRes = await this.drawMultiLineTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: 8,
      font: fontFamilyBold,
      row: puissanceRow,
      border: { width: 1, color: this.COLOR.black },
      paddingHorizontal: 4,
    });
    yTableCurrent = yTableCurrent - 1; // substract the border

    // ----------- body data -----------
    const bodyRowHeight = 10;
    const bodyFontSize = 7;
    const nbrAnnees = data[0].Opex[0].lineOpexTwentyYearsMaintenance.length;
    // column labels "Année"
    for (let indexAnnee = 0; indexAnnee < nbrAnnees; indexAnnee++) {
      yTableCurrent = yTableCurrent - bodyRowHeight;
      const row = [{ text: `Année ${indexAnnee+1}`, width: colOneWidth, height: bodyRowHeight, align: 'left',  }];
      for (let i = 0; i < data.length; i++) {
        for (let indexOpex = 0; indexOpex < data[i].Opex.length; indexOpex++) {
          const opexItem = data[i].Opex[indexOpex];
          const value = opexItem.lineOpexTwentyYearsMaintenance[indexAnnee]
          row.push({ 
            text: `${this.formatNumberOrText(value, 2)} €`, 
            width: colWidth, 
            height: bodyRowHeight, 
            align: 'center'  
          });
        }
      }
      await this.drawMultiLineTableRow({
        page, 
        x: xStartTable, 
        y: yTableCurrent, 
        size: bodyFontSize,
        font: fontFamily,
        row: row,
        paddingHorizontal: 4,
      });
    }
    
    // ----------- Total row -----------
    const totalRowHeight = 13;
    const totalFontSize = 8;
    const totalRow = [{ text: "Total", width: colOneWidth, height: totalRowHeight, align: 'left', font: fontFamilyBold }];
    for (let indexCompteur = 0; indexCompteur < data.length; indexCompteur++) {
      const compteur = data[indexCompteur];
      for (let indexOpex = 0; indexOpex < compteur.Opex.length; indexOpex++) {
        const item = compteur.Opex[indexOpex];
        totalRow.push({ 
          text: `${this.formatNumberOrText(item.totalCoutMaintenanceOpex, 2)} €`, 
          width: colWidth, 
          height: totalRowHeight, 
          align: 'center', 
          bgColor: this.COLOR.darkGrey
        })
      }
    }
    yTableCurrent = yTableCurrent - totalRowHeight;
    const totalRowRes = await this.drawMultiLineTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: totalFontSize,
      font: fontFamily,
      row: totalRow,
      paddingHorizontal: 4,
    });
  }
  async drawTableRecapitulatif({page, x=0, y=0, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    const headerBgColor = [0.078, 0.372, 0.509];
    const bgRowColor1 = [0.745, 0.901, 0.96];
    const bgRowColor2 = [0.843, 0.901, 0.96];
    const bgRowColor3 = [0.647, 0.784, 0.921];
    const widthCaracteristique = 201;
    const widthScenario = 70;
    const rowHeight = 15;
    const nbrScenario = 1;
    
    const headers = [
      { text: "Caractéristiques", width: widthCaracteristique, height: rowHeight, textColor: this.COLOR.white, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Scenario 1", width: widthScenario, height: rowHeight, textColor: this.COLOR.white, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
    ];
    const widthOfTable = headers.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.width;
    }, 0);
    let xStartTable = x - (widthOfTable/2);
    let yTableCurrent = y;
    const body = [
      [
        { text: "Puissance crête totale (kWc)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `-`, width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Toitures (kWc)", width: widthCaracteristique, height: rowHeight, align: 'center', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor2, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.sommeProductionToiture, 2)}`, width: widthScenario, height: rowHeight, align: 'right', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor2, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Ombrières (kWc)", width: widthCaracteristique, height: rowHeight, align: 'center', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.sommeProductionOmbriere, 2)}`, width: widthScenario, height: rowHeight, align: 'right', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "SOL (kWc)", width: widthCaracteristique, height: rowHeight, align: 'center', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.sommeProductionSol, 2)}`, width: widthScenario, height: rowHeight, align: 'right', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Surface totale (m²)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Toitures (m²)", width: widthCaracteristique, height: rowHeight, align: 'center', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor2, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor2, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Ombrières (m²)", width: widthCaracteristique, height: rowHeight, align: 'center', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', font: fontFamilyItalic, textColor: this.COLOR.black, bgColor: bgRowColor3, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Production du site (kWh)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.sommeProduction, 2)}`, width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Autoconsommation individuelle (kWh)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.sommeAutoConsommerIndividuelle, 2)}`, width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Surplus non consommé par le site (kWh)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(this.pdfData.Reste_A_Vendre, 2)}`, width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "TAC (%)*", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "TAP (%)*", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Investissement (€)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "RSI (ans)*", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Economie énergétique à 6 ans (€)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Economie énergétique à 9 ans (€)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: bgRowColor1, borderWidth: 1, borderColor: this.COLOR.black },
      ],
      [
        { text: "Economie énergétique à 12 ans (€)", width: widthCaracteristique, height: rowHeight, align: 'left', font: fontFamilyBold, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: "-", width: widthScenario, height: rowHeight, align: 'right', textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
    ];
    // draw header
    yTableCurrent = yTableCurrent - rowHeight; // move down cursor
    await this.drawTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      font: fontFamilyBold,
      padding: 2,
      row: headers,
    });
    
    // draw body
    for (let index = 0; index < body.length; index++) {
      const row = body[index];
      yTableCurrent = yTableCurrent - rowHeight; // move down cursor
      await this.drawTableRow({
        page, 
        x: xStartTable, 
        y: yTableCurrent, 
        font: fontFamily,
        padding: 2,
        row: row,
      });
    }

    return yTableCurrent;
  }
  async drawTableCompteurInvest({page, x=0, y=0, data, fontFamily, fontFamilyItalic, fontFamilyBold, fontFamilyBoldItalic}){
    const widthCol1 = 75;
    const widthCol2 = 65;
    const widthCol3 = 50;
    const widthCol4 = 50;
    const widthCol5 = 50;
    const widthCol6 = 50;
    const widthCol7 = 70;
    const widthCol8 = 70;
    const headerRowHeight = 50;
    const headerBgColor = this.COLOR.white;
    const headerFontSize = 8;
    const rowHeight = 15;
    const bodyFontSize = 8;
    
    const headers = [
      { text: "PDL", width: widthCol1, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Mode d'installation", width: widthCol2, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Nbr panneaux", width: widthCol3, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Superficie PV (m2)", width: widthCol4, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Puissance crête (kWc)", width: widthCol5, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Production annuelle kWh/an", width: widthCol6, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Investissement PV TTC (CAPEX)", width: widthCol7, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
      { text: "Maintenance 20 ans TTC (OPEX) (+2%/an)", width: widthCol8, height: headerRowHeight, textColor: this.COLOR.black, bgColor: headerBgColor, borderWidth: 1, borderColor: this.COLOR.black },
    ];

    const widthOfTable = headers.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.width;
    }, 0);
    let xStartTable = x - (widthOfTable/2);
    let yTableCurrent = y - headerRowHeight;

    // draw header
    await this.drawMultiLineTableRow({
      page, 
      x: xStartTable, 
      y: yTableCurrent, 
      size: headerFontSize,
      font: fontFamilyBold,
      row: headers,
    });

    
    // ------------ draw body col 1 "compteur" ------------ 
    const compteurColHeight = data.installations.length * rowHeight;// calculate table height
    let xColCompteur = xStartTable;
    let yColCompteur = yTableCurrent - compteurColHeight;
    await this.drawMultiLineTableRow({
      page, 
      x: xColCompteur, 
      y: yColCompteur, 
      size: bodyFontSize,
      font: fontFamily,
      row: [
        { text: `${data.num_compteur}`, width: widthCol1, height: compteurColHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
      ],
    });

    // ------------ draw body data ------------ 
    const body = data.installations.map(d=> {
      const col = [
        { text: d.mode.toString() || "", width: widthCol2, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${d.nbrPanneaux}`, width: widthCol3, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(d.superficie, 2)}`, width: widthCol4, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(d.puissance, 2)}`, width: widthCol5, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(d.production, 2)}`, width: widthCol6, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(d.investissementCapex, 2)} €`, width: widthCol7, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.grey100, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(d.investissementOpex, 2)} €`, width: widthCol8, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.lightYellow, borderWidth: 1, borderColor: this.COLOR.black },
      ]
      return col;
    });

    let dataTableXPos = xStartTable + widthCol1; // increase X pos to Col 2
    for (let i = 0; i < body.length; i++) {
      const row = body[i];
      yTableCurrent = yTableCurrent - rowHeight; // move down
      // draw table row
      await this.drawMultiLineTableRow({
        page, 
        x: dataTableXPos, 
        y: yTableCurrent, 
        size: bodyFontSize,
        font: fontFamily,
        row: row,
      });
    }

    // ------------ draw total ------------ 
    yTableCurrent = yTableCurrent - rowHeight; // move down
    await this.drawMultiLineTableRow({
      page, 
      x: xStartTable + widthCol1, 
      y: yTableCurrent, 
      size: bodyFontSize,
      font: fontFamilyBold,
      row: [
        { text: "Total", width: widthCol2, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.blue100, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${data.installationsTotal.nbrPanneaux}`, width: widthCol3, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.installationsTotal.superficie, 2)}`, width: widthCol4, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.installationsTotal.puissance, 2)}`, width: widthCol5, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.installationsTotal.production, 2)}`, width: widthCol6, height: rowHeight, textColor: this.COLOR.greenGrassDark, bgColor: this.COLOR.white, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.installationsTotal.investissementCapex, 2)} €`, width: widthCol7, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.grey100, borderWidth: 1, borderColor: this.COLOR.black },
        { text: `${this.formatNumberOrText(data.installationsTotal.investissementOpex, 2)} €`, width: widthCol8, height: rowHeight, textColor: this.COLOR.black, bgColor: this.COLOR.lightYellow, borderWidth: 1, borderColor: this.COLOR.black },
      ],
    });

    return yTableCurrent;
  }
  async drawMultiLineTableRow({page, x=0, y=0, size=10, font, row, border, paddingHorizontal=0,paddingVertical=0}){
    let xCurrent = x;
    let yCurrent = y;
    let currentRowFinalWidth = 0;
    let currentRowFinalHeight = 0;
    for (let i = 0; i < row.length; i++) {
      const line = row[i];
      const { rectangleWidth, rectangleHeight } = await this.drawWrappedMultiLineText({
        page: page, 
        text: line.text, 
        x: xCurrent, 
        y: yCurrent, 
        font: line.font || font, 
        size: size, 
        align: line.align || 'center', 
        textColor: line.textColor, 
        width: line.width, 
        height: line.height,
        borderWidth: line.borderWidth,
        borderColor: line.borderColor,
        bgColor: line.bgColor || [1,1,1],
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
      });
      currentRowFinalWidth = currentRowFinalWidth + rectangleWidth; // calculate width of the row
      currentRowFinalHeight = Math.max(currentRowFinalHeight, rectangleHeight); // get maximum height of the row
      xCurrent = xCurrent + line.width; // move X to the right
    }

    // draw border arrownd line
    if(border) {
      this.drawRoundedRectangle({ 
        page, 
        x: x, 
        y: y+currentRowFinalHeight, 
        width: currentRowFinalWidth, 
        height: currentRowFinalHeight,  
        cornerRadius: border.radius, 
        borderWidth: border.width, 
        borderColor: border.color,
      });
    }
    return { 
      width: currentRowFinalWidth, 
      height: currentRowFinalHeight, 
      yAfter: y-currentRowFinalHeight 
    }
  }
  async drawTableRow({page, x=0, y=0, size=10, font, row, padding=0}){
    let xCurrent = x;
    let yCurrent = y;
    for (let i = 0; i < row.length; i++) {
      const line = row[i];
      this.drawAlignedText({
        page: page, 
        text: line.text, 
        x: xCurrent, 
        y: yCurrent, 
        font: line.font || font, 
        size: size, 
        align: line.align || 'center', 
        textColor: line.textColor, 
        width: line.width, 
        height: line.height,
        borderWidth: line.borderWidth,
        borderColor: line.borderColor,
        bgColor: line.bgColor || [1,1,1],
        padding: padding,
      });
      xCurrent = xCurrent + line.width; // move X to the right
    }
  }


  // --------------------- custom text drawing --------------------- 
  async drawAlignedText({page, text, x= 0, y= 0, font, size, align, textColor= [0, 0, 0], width=0, height=0, borderWidth=0, borderColor,bgColor,padding=0}){
    const widthText = font.widthOfTextAtSize(text, size);
    const heightText = font.heightAtSize(size) - 2;
    // calculate center position
    let xPosition = x + width / 2;
    if(align == 'center') xPosition = xPosition - widthText/2;
    if(align == 'left')  xPosition = x + padding;
    if(align == 'right')  xPosition = x + width - widthText - padding;
    // draw rectangle
    if(width > 0 && (borderWidth > 0 || bgColor?.length==3)){
      let rectProps = {
        x: x,
        y: y,
        width: width,
        height: height>0 ? height : heightText,
        borderWidth: borderWidth,
      }
      if(bgColor) rectProps.color = rgb(bgColor[0], bgColor[1], bgColor[2]);
      if(borderColor) rectProps.borderColor = rgb(borderColor[0], borderColor[1], borderColor[2]);
      page.drawRectangle(rectProps);
    }
    if(height>0) y = y + (height/2) - (heightText/2)
    // draw text
    page.drawText(text, {
      x: xPosition,
      y: y,
      size: size,
      font: font,
      color: rgb(textColor[0], textColor[1], textColor[2]),
    });
  }
  async drawWrappedMultiLineText({page, text, x= 0, y= 0, font, size, align, textColor= [0, 0, 0], width=0, height=0, borderWidth=0, borderColor,bgColor,paddingHorizontal=0,paddingVertical=0}){
    // Prepare for multi-line text layout
    const multiText = layoutMultilineText(text, {
        alignment: align || 'left',
        fontSize: size,
        font: font,
        lineHeight: size * 1.2, // Line height is often 120% of font size
        bounds: { width: width-(paddingHorizontal*2), height: 1000 } // Set a very high height to ensure all text is considered
    });

    // Calculate the total height of the text content
    const textContentHeight = multiText.lines.length * size * 1.2;

    // Adjust vertical starting position based on the total height of the laid out text
    let startingPosition = y;
    startingPosition = y + (height > 0 ? (height - textContentHeight) / 2 : 0) + textContentHeight - size /* * 1.2 */ + paddingVertical;
    
    // Draw border rectangle if required
    let rectangleWidth = width;
    let rectangleHeight = (height > 0 ? height : textContentHeight) + (2*paddingVertical);
    if (width > 0 && (borderWidth > 0 || bgColor?.length==3) ) {
        let rectProps = {
            x: x,
            y: y,
            width: rectangleWidth,
            height: rectangleHeight,
            borderWidth: borderWidth,
          };
          if (bgColor) rectProps.color = rgb(bgColor[0], bgColor[1], bgColor[2]);
          if (borderColor) rectProps.borderColor = rgb(borderColor[0], borderColor[1], borderColor[2]);
        page.drawRectangle(rectProps);
    }

    // Draw each line of text
    multiText.lines.forEach((line) => {
        const widthText = font.widthOfTextAtSize(line.text, size);
      
        // calculate center position
        let lineX = x;
        if (align === 'left') lineX += paddingHorizontal;
        if (align === 'center') lineX += (width - widthText) / 2;
        if (align === 'right') lineX += width - widthText - paddingHorizontal;

        page.drawText(line.text, {
            x: lineX,
            y: startingPosition,
            size: size,
            font: font,
            color: rgb(textColor[0], textColor[1], textColor[2]),
        });
        startingPosition -= size * 1.2; // Move down for the next line
    });

    return { rectangleWidth, rectangleHeight };
  }
  async drawMultiLineText({page, text, x= 0, y= 0, font, size, lineHeight, align, textColor= [0, 0, 0], width=0}){
    const lineSpace = lineHeight || size * 1.2; // Line height is often 120% of font size
    const heightText = font.heightAtSize(size) - (size * 0.2);
    // Prepare for multi-line text layout
    const multiText = layoutMultilineText(text, {
        alignment: align || 'left',
        fontSize: size,
        font: font,
        lineHeight: lineSpace,
        bounds: { width: width, height: 1000 }
    });

    // Draw each line of text
    let startingPosition = y;
    for (let i = 0; i < multiText.lines.length; i++) {
      const line = multiText.lines[i];
      page.drawText(line.text, {
        x: x,
        y: startingPosition,
        size: size,
        font: font,
        lineHeight: lineSpace,
        maxWidth: width,
        color: rgb(textColor[0], textColor[1], textColor[2]),
      });
      // Move down for to the next line when its not the last line
      if(i < multiText.lines.length - 1){
        startingPosition = startingPosition - lineSpace;
      }
    }

    return startingPosition - heightText;
  }

  async drawListPointText({page, text, x= 0, y= 0, font, size=10, textColor= [0, 0, 0], width=0}){
    let linesSpace = size / 2;
    let yPosition = y;
    for (let i = 0; i < text.length; i++) {
      const line = text[i];
      page.drawText("•",{
        x: x,
        y: yPosition,
        font: font,
        size: size + 1.5,
        color: rgb(textColor[0], textColor[1], textColor[2]), 
      });
      yPosition = await this.drawMultiLineText({
        page, 
        text: line, 
        x: x + 15,
        y: yPosition,
        font: font,
        size: size,
        textColor: textColor, 
        width: width,
      });
      yPosition = yPosition - linesSpace; // line space
    }
    return yPosition;
  }

  // ------------- svg shape draw ------------- 
  drawArrow({ page, start, end, color = [0, 0, 0], opacity = 1, thickness=1 }) {
    const x1 = start.x;
    const y1  = start.y;
    const x2 = end.x;
    const y2  = end.y;
    // Draw the main line
    page.drawLine({
      start: { x: x1, y: y1 },
      end: { x: x2, y: y2 },
      thickness: thickness,
      color: rgb(color[0], color[1], color[2]),
      opacity: opacity,
    });

    // Parameters for the arrowhead
    const headLength = 10;  // Length of the arrowhead lines
    const headWidth = 5;    // Width of the arrowhead base

    // Calculate the angle of the line
    const angle = Math.atan2(y2 - y1, x2 - x1);

    // Calculate the two sides of the arrowhead
    const arrowLeftX = x2 - headLength * Math.cos(angle - Math.PI / 6);
    const arrowLeftY = y2 - headLength * Math.sin(angle - Math.PI / 6);
    const arrowRightX = x2 - headLength * Math.cos(angle + Math.PI / 6);
    const arrowRightY = y2 - headLength * Math.sin(angle + Math.PI / 6);

    // Draw the left side of the arrowhead
    page.drawLine({
        start: { x: x2, y: y2 },
        end: { x: arrowLeftX, y: arrowLeftY },
        thickness: thickness,
        color: rgb(color[0], color[1], color[2]),
        opacity: opacity,
    });

    // Draw the right side of the arrowhead
    page.drawLine({
        start: { x: x2, y: y2 },
        end: { x: arrowRightX, y: arrowRightY },
        thickness: thickness,
        color: rgb(color[0], color[1], color[2]),
        opacity: opacity,
    });
  }
  drawSvgFromPath({ page, x1=0, y1=0, x2=0, y2=0, color = [0, 0, 0], opacity = 1, svgPath, svgPathUnit }) {
    // Calculate the angle and length
    const deltaX = x2 - x1;
    const deltaY = y2 - y1;
    const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI); // Convert radians to degrees
    const length = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

    // Compute the scale based on the arrow path's original width
    const scale = length / svgPathUnit;
  
    // Draw the arrow with the necessary transformations
    page.drawSvgPath(svgPath, {
      x: x1,
      y: y1,
      color: rgb(color[0], color[1], color[2]),
      opacity: opacity,
      rotate: degrees(angle),
      scale: scale,
    });  
  }
  drawRoundedRectangle({ page, x, y, width, height, cornerRadius=0, borderWidth=1, borderColor = [0, 0, 0], bgColor, opacity = 1 }) {
    // Start the path at the top-left corner, right after the first rounded corner
    const svgPath = [
      `M ${cornerRadius} 0`, // Start path
      `L ${width - cornerRadius}, 0`, // Top horizontal line
      `C ${width - cornerRadius / 2} 0, ${width} ${cornerRadius / 2}, ${width} ${cornerRadius}`, // Top-right corner
      `L ${width},${height - cornerRadius}`, // Right vertical line
      `C ${width} ${height - cornerRadius / 2}, ${width - cornerRadius / 2} ${height}, ${width - cornerRadius} ${height}`, // Bottom-right corner
      `L ${cornerRadius},${height}`, // Bottom vertical line
      `C ${cornerRadius / 2} ${height}, 0 ${height - cornerRadius / 2}, 0 ${height - cornerRadius}`, // Bottom-left corner
      `L 0,${cornerRadius}`, // Left vertical line
      `C 0,${cornerRadius / 2} ${cornerRadius / 2},0, ${cornerRadius},0`, // Top-left corner
      `Z` // Close path
    ].join(' ');

    // Draw path as black line
    page.drawSvgPath(svgPath, { 
      x: x, 
      y: y,
      borderWidth: borderWidth,
      borderColor: rgb(borderColor[0], borderColor[1], borderColor[2]),
      bgColor: bgColor,
      opacity: opacity
    })
  }

  // --------------------- draw image --------------------- 
  async drawRoundedImage(pdfDoc, page, imageFile, x, y, imageWidth, imageHeight, radius=0){
    if (imageFile) {
      // Convert the image file to bytes
      const imageBytes = await this.roundedImage(imageFile, imageWidth, imageHeight, radius);
      
      // Check the image type and use the appropriate function
      if (imageFile.type === "image/png") {
        // const imageBytes = await imageFile.arrayBuffer();

        // embed the image to the pdf
        const imagePage = await pdfDoc.embedPng(imageBytes);
        
        // Add the image to the PDF
        page.drawImage(imagePage, {
          x: x,
          y: y,
          width: imageWidth,
          height: imageHeight,
        });
        
      } else if (imageFile.type === "image/jpeg") {
        // Convert jpeg image to PNG image
        // const convertedImageBytes = await this.convertJpegToPng(imageBytes);

        // embed the image to the pdf
        const imagePage = await pdfDoc.embedPng(imageBytes);
        // Add the image to the PDF
        page.drawImage(imagePage, {
          x: x,
          y: y,
          width: imageWidth,
          height: imageHeight,
        });
      } else {
        console.error("Unsupported image type. Please use PNG or JPEG.");
        page.drawRectangle({
          x: x,
          y: y,
          width: imageWidth,
          height: imageHeight,
          color: rgb(0.94, 0.96, 0.97),
          borderColor: rgb(0.60, 0.64, 0.70),
          borderWidth: 1.5,
        });
      }
    } else {
      console.warn("No Image Selected. Please use PNG or JPEG.");
      page.drawRectangle({
        x: x,
        y: y,
        width: imageWidth,
        height: imageHeight,
        color: rgb(0.94, 0.96, 0.97),
        borderColor: rgb(0.60, 0.64, 0.70),
        borderWidth: 1.5,
      });
    }
  }
  async drawApexChart({pdfDoc, page, chartId, x, y, width, height}){
    const imagChartDataURL = await this.convertApexCartToImage(chartId);
    if (imagChartDataURL) {
      // Convert the image file to bytes
      const imageBytes = await fetch(imagChartDataURL).then((res) => res.arrayBuffer());
      const imagePage = await pdfDoc.embedPng(imageBytes);
      page.drawImage(imagePage, {
        x: x,
        y: y,
        width: width,
        height: height,
      });
    }
  }

  // --------------------- convert Images --------------------- 
  async roundedImage(imageFile, imageWidth, imageHeight, radius) {
    // Convert the image file to bytes
    const imgBytes = await imageFile.arrayBuffer();

    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = imageWidth;
        canvas.height = imageHeight;
        
        // Draw the image onto the canvas
        const width = imageWidth;
        const height = imageHeight;
        const x = 0;
        const y = 0;

        // Begin path for rounded rectangle
        context.beginPath();
        context.roundRect(x, y, width, height, radius);

        // Apply clipping path
        context.clip();
        // Draw image within clipped region
        context.drawImage(image, 0, 0, width, height);
        context.restore();


        // Get the PNG bytes from the canvas
        canvas.toBlob(
          (blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(new Uint8Array(reader.result));
            };
            reader.readAsArrayBuffer(blob);
          },
          "image/png",
          1 // Quality (1 is the highest)
        );
      };

      // Set the JPEG bytes as the source for the image
      const blob = new Blob([imgBytes], { type: "image/jpeg" });
      image.src = URL.createObjectURL(blob);

      image.onerror = (error) => {
        reject(error);
      };
    });
  }
  async convertJpegToPng(jpegBytes) {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = image.width;
        canvas.height = image.height;

        // Draw the JPEG image onto the canvas
        context.drawImage(image, 0, 0, image.width, image.height);

        // Get the PNG bytes from the canvas
        canvas.toBlob(
          (blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve(new Uint8Array(reader.result));
            };
            reader.readAsArrayBuffer(blob);
          },
          "image/png",
          1 // Quality (1 is the highest)
        );
      };

      // Set the JPEG bytes as the source for the image
      const blob = new Blob([jpegBytes], { type: "image/jpeg" });
      image.src = URL.createObjectURL(blob);

      image.onerror = (error) => {
        reject(error);
      };
    });
  }
  async convertApexCartToImage(chartId) {
    const chartInstance = window.Apex._chartInstances.find(chart => chart.id === chartId);
    const base64 = await chartInstance.chart.dataURI();
    return base64.imgURI;
  }

  // --------------------- formatters --------------------- 
  capitalizeWords(text) {
    if(!text) return "";
    // Split the text into an array of words
    let words = text.split(' ');
    // Iterate through each word and capitalize the first letter
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    // Join the words back into a single string and return
    return words.join(' ');
  }
  to_fixed2LocaleStringEuro(num) {
    if(!isNaN(num) && num !== null && num !== undefined && num !== ""){
        // num is number
        if(num == 0) return "0";
        return Number(parseFloat(num).toFixed(2)).toLocaleString("fr-FR").replace(/\u202F/g, ' ').toString() + " €";
    }else{
        // num is text
        if(num !== null && num !== undefined && num !== ""){
            return num
        }
        return ""
    }
  }
  to_fixed2OrText(num) {
    if(!isNaN(num) && num !== null && num !== undefined && num !== ""){
        // num is number
        return Number(parseFloat(num).toFixed(2)).toLocaleString("fr-FR").replace(/\u202F/g, ' ').toString() + "";
    }else{
        // num is text
        if(num !== null && num !== undefined && num !== ""){
            return num
        }
        return ""
    }
  }
  formatNumberOrText(num, tofFixedNumber) {
    if(!isNaN(num) && num !== null && num !== undefined && num !== ""){
        // num is number
        return Number(parseFloat(num).toFixed(tofFixedNumber)).toLocaleString("fr-FR").replace(/\u202F/g, ' ').toString() + "";
    }else{
        // num is text
        if(num !== null && num !== undefined && num !== ""){
            return num
        }
        return ""
    }
  }
}

export default PDFSolarCollectifGenerator;